module.exports = __webpack_public_path__ + "img/b4.23886a86.jpg";